import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Keyboard,
  HashNavigation,
  Autoplay,
} from 'swiper/modules';

export const swiperSlider = async (err) => {
  if (err) {
    console.error(err);
  }
  /*
   * Default twocol Slider
   */
  new Swiper('.swiper__default', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Keyboard],
    spaceBetween: 30,
    preloadImages: true,
    loop: true,
    speed: 500,
    allowTouchMove: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    lazy: {
      enabled: false,
      loadPrevNext: true, // Loads next/prev slide images
      loadOnTransitionStart: true,
    },
  });

  /*
   * Posttype teasers Slider e.g. events
   */
  new Swiper('.swiper__posttype-teaser', {
    // configure Swiper to use modules
    modules: [Pagination],
    preloadImages: true,
    loop: true,
    speed: 500,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  /*
   * Fullwidth onecol Slider
   */
  new Swiper('.swiper__onecol-fullwidth', {
    // configure Swiper to use modules
    modules: [Pagination, Keyboard, Autoplay],
    spaceBetween: 0,
    preloadImages: true,
    loop: true,
    speed: 500,
    allowTouchMove: true,
    keyboard: {
      enabled: true,
    },
    autoplay: {
      delay: 2000,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  /*
   * Threecol teasers Slider
   */
  //var carouselIds = [];
  //var carouselInstances = [];
  document.querySelectorAll('.fourcol__teaser-slider').forEach((el) => {
    let carouselId = el.getAttribute('id');

    if (carouselId) {
      new Swiper(`#${carouselId} .swiper__threecol-teasers`, {
        // configure Swiper to use modules
        modules: [Navigation, Pagination, Keyboard],
        spaceBetween: 30,
        preloadImages: true,
        loop: false,
        speed: 500,
        allowTouchMove: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: `#${carouselId} .swiper-button-next`,
          prevEl: `#${carouselId} .swiper-button-prev`,
        },
        pagination: {
          el: `#${carouselId} .swiper-pagination`,
          clickable: true,
        },
      });
      //carouselIds.push(carouselId);
      //carouselInstances.push(carouselInstance);
    }
  });

  /*   function detectMobilePhoneViewport(x) {
    carouselInstances.forEach((currentInstance) => {
      if (x.matches) {
        // If media query matches

        currentInstance.destroy(true, true);
        console.log('destroyed');
      } else {
        //currentInstance.init();
        currentInstance.init();
        console.log('initialized:', currentInstance);
      }
    });
  } */

  // Create a MediaQueryList object
  // var x = window.matchMedia('(max-width: 575px)');

  // Call listener function at run time
  //detectMobilePhoneViewport(x);

  // Attach listener function on state changes
  /*   x.addEventListener('change', function () {
    console.log('changed');
    detectMobilePhoneViewport(x);
  }); */

  /*
   * Impressionen Slider
   */

  const impressionsSlides = document.querySelectorAll(
    '.swiper-impressionen .swiper-wrapper .swiper-slide',
  );
  if (impressionsSlides) {
    const closeBtn = document.querySelector('.close-btn'),
      swiperNav = document.querySelector('.swiper-nav'),
      htmlEl = document.querySelector('html');

    impressionsSlides.forEach((impressionenSlide, index) => {
      impressionenSlide.addEventListener('click', (e) => {
        //console.log(impressionenSlide.getAttribute('data-hash'));

        htmlEl.classList.add('fullscreen-slideshow');

        impressionenSlide.parentElement.parentElement.parentElement.classList.add(
          'swiper-active',
        );

        swiperNav.classList.add('show-nav');

        var impressionSlider = new Swiper('.swiper__impressionen', {
          // configure Swiper to use modules
          modules: [Navigation, Pagination, Keyboard, HashNavigation],
          preloadImages: true,
          loop: true,
          speed: 500,
          allowTouchMove: true,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: '.swiper-impressionen .swiper-button-next',
            prevEl: '.swiper-impressionen .swiper-button-prev',
          },
          pagination: {
            el: '.swiper-impressionen .swiper-pagination',
            clickable: true,
            type: 'fraction',
          },
        });

        impressionSlider.slideTo(index, 1);

        closeBtn.addEventListener('click', (e) => {
          htmlEl.classList.remove('fullscreen-slideshow');
          closeBtn.parentElement.parentElement.classList.remove(
            'swiper-active',
          );
          swiperNav.classList.remove('show-nav');
          impressionSlider.destroy();

          e.preventDefault();
        });

        e.preventDefault();
      });
    });
  }
};

import.meta.webpackHot?.accept(swiperSlider);
